import toast from 'react-hot-toast';

// Success Toast
export const showSuccessToast = (message) => {
  toast.success(message, {
    duration: 4000,
    position: 'top-right',
    style: {
      background: '#10b981',
      color: '#fff',
      fontWeight: '600',
      borderRadius: '8px',
      padding: '16px',
      fontSize: '14px',
    },
    icon: '✓',
  });
};

// Error Toast
export const showErrorToast = (message) => {
  toast.error(message, {
    duration: 4000,
    position: 'top-right',
    style: {
      background: '#ef4444',
      color: '#fff',
      fontWeight: '600',
      borderRadius: '8px',
      padding: '16px',
      fontSize: '14px',
    },
    icon: '✕',
  });
};

// Loading Toast
export const showLoadingToast = (message) => {
  return toast.loading(message, {
    position: 'top-right',
    style: {
      background: '#3b82f6',
      color: '#fff',
      fontWeight: '600',
      borderRadius: '8px',
      padding: '16px',
      fontSize: '14px',
    },
  });
};

// Update Loading Toast to Success
export const updateLoadingToastSuccess = (toastId, message) => {
  toast.dismiss(toastId);
  showSuccessToast(message);
};

// Update Loading Toast to Error
export const updateLoadingToastError = (toastId, message) => {
  toast.dismiss(toastId);
  showErrorToast(message);
};
